import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import { SettingsHeader } from "~/components/layout/settings-header";
import ComingSoon from "~/components/miscellaneous/coming-soon";
import { Form, useForm } from "~/components/ui/form";

export const Route = createFileRoute("/_main/settings/_layout/online-orders/")({
  component: OnlineOrders,
});

function OnlineOrders() {
  const { t } = useTranslation("common");

  return (
    <>
      <SettingsHeader title={t("online_orders")} />
      <div className="flex flex-col gap-4"></div>
    </>
  );
}
